import React from "react";
import ContactosEstruturas from "../../components/ContactosEstruturas";
import Section from "../../components/Header";
import Estruturas from "../../imgs/header/estruturas.jpg";
import { withNamespaces } from 'react-i18next';

// eslint-disable-next-line import/no-anonymous-default-export
const ContactosEstruturas_index = ({t}) => {
  return (
    <>
      <div id="start" className="fantasmaAncora"></div>
      <div id="main">
        <Section backgroundImage={Estruturas} title={t('moduleContactosEstruturas:T')} />
        <ContactosEstruturas />
      </div>
    </>
  );
};

export default withNamespaces() (ContactosEstruturas_index);